import createDataContext from './createDataContext';
import { api } from '../api/api';

const websitesReducer = (state, action) => {
  switch (action.type) {
    case 'REQUEST':
      return {
        ...state,
        loading: true,
        error: false,
      };
    case 'SUCCESS':
      return {
        ...state,
        loading: false,
        websites: action.payload,
      };
    case 'ERROR':
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

const loadWebsites = (dispatch) => async () => {
  try {
    dispatch({
      type: 'REQUEST',
    });
    const response = await api.get('/websites', {});
    dispatch({
      type: 'SUCCESS',
      payload: response.data,
    });
  } catch (e) {
    dispatch({
      type: 'ERROR',
      payload: 'Unable to load websites',
    });
  }
};

export const { Context, Provider } = createDataContext(
  websitesReducer,
  {
    loadWebsites,
  },
  {
    websites: [],
    error: '',
    loading: false,
  }
);
